<script setup>
import {onBeforeMount, onUnmounted, ref} from "vue";
import NavigationBar from "@/components/NavigationBar.vue";
import WaitingIcon from "@/pages/PaymentAccept/WaitingIcon.vue";
import ErrorIcon from "@/pages/PaymentAccept/ErrorIcon.vue";
import SuccessIcon from "@/pages/PaymentAccept/SuccessIcon.vue";
import {Api} from "@/service/api";
import {useRoute} from 'vue-router'
import stringUtils from "../../service/stringUtils";

const order = ref({})

const route = useRoute()
const orderId = ref("")


let pollingInterval = null

const startPolling = () => {
    pollingInterval = setInterval(async () => {
        try {
            order.value = await Api.getOrderPaymentById(orderId.value)

            if (order.value?.payment_status === 'success') {
                stopPolling()
            }
        } catch (error) {
            console.error('Polling error:', error)
        }
    }, 250)
}

const stopPolling = () => {
    if (pollingInterval) {
        clearInterval(pollingInterval)
        pollingInterval = null
    }
}


onBeforeMount(async () => {
    orderId.value = route.query.order_id.toString()
    startPolling()

    // order.value = await Api.getOrderPaymentById(orderId.value)
})


onUnmounted(() => {
    stopPolling()
})



</script>
<template>
<div class="flex w-full min-h-screen">
    <NavigationBar/>
    <div class="w-full flex flex-col lg:flex-row gap-4 lg:gap-[24px] justify-center mt-4 lg:mt-[48px] px-4 lg:px-6">
        <div class="w-full h-fit bg-white p-4 lg:p-[25px] lg:w-auto lg:min-w-[550px] border border-[#e1e1e1] rounded-[16px]">
            <div class="font-bold text-[18px] lg:text-[20px] mb-4 lg:mb-[32px]">Информация об оплате</div>
            <div class="w-full flex items-center justify-center mb-5">
                <div
                    class="size-16 rounded-full"
                    :class="{
                        'bg-green-200': order?.payment_status === 'succeeded',
                        'bg-blue-200': order?.payment_status === 'in_process',
                        'bg-red-200': order?.payment_status === 'error' | order?.payment_status === 'canceled',
                    }"
                >
                    <SuccessIcon v-if="order?.payment_status === 'succeeded'"/>
                    <WaitingIcon v-if="order?.payment_status === 'in_process'"/>
                    <ErrorIcon v-if="order?.payment_status === 'canceled'"/>
                </div>
            </div>
            <div v-if="order?.payment_status === 'success'" class="flex w-fit mx-auto">
                <div v-if="order.order_type === 'SUBSCRIPTION'">
                    Тариф {{ order }} активирован
                </div>
                <div v-if="order.order_type === 'TRANSACTIONS'">
                    Дополнительные {{ order?.transactions_count }} приобретены
                </div>
            </div>
            <div v-else-if="order?.payment_status === 'in_process'" class="flex w-fit mx-auto">
                Заказ в обработке
            </div>
            <div v-else-if="order?.payment_status === 'canceled'" class="flex w-fit mx-auto">
                Оплата не прошла
            </div>
            <div v-if="order.order_type === 'SUBSCRIPTION'"  class="w-full flex flex-col gap-2 mt-4 bg-[#edf2f8] rounded-[14px] p-4">
                <div class="px-2 font-bold">
                    Детали заказа:
                </div>
                <div class="flex justify-between px-2">
                    <div>Тариф</div>
                    <div>{{ order?.subscription_plan_name }}</div>
                </div>
                <div class="flex justify-between px-2">
                    <div>Период</div>
                    <div>{{ order?.month_count }} {{ stringUtils.lengthToMonthName(order?.month_count) }}</div>
                </div>
                <div class="flex justify-between px-2">
                    <div>Транзакций</div>
                    <div>{{order?.transactions_rate_per_month}}/мес.</div>
                </div>
                <div class="flex justify-between px-2">
                    <div>Оплачено</div>
                    <div>{{ order?.price }} руб.</div>
                </div>
            </div>
            <div v-if="order.order_type === 'TRANSACTIONS'"  class="w-full flex flex-col gap-2 mt-4 bg-[#edf2f8] rounded-[14px] p-4">
                <div class="px-2 font-bold">
                    Детали заказа:
                </div>
                <div class="flex justify-between px-2">
                    <div>Транзакций</div>
                    <div>{{order?.transactions_count}}</div>
                </div>
                <div class="flex justify-between px-2">
                    <div>Оплачено</div>
                    <div>{{ order?.price }} руб.</div>
                </div>
            </div>
            <div class="w-full flex mt-2 justify-between">
                <router-link :to="{'path': '/me'}" class="bg-blue-500 px-4 py-2 text-white cursor-pointer hover:bg-blue-600 duration-150 transition-all rounded-[10px]">
                    Перейти в личный кабинет
                </router-link>
                <router-link :to="{'path': '/'}" class="bg-blue-500 px-4 py-2 text-white cursor-pointer hover:bg-blue-600 duration-150 transition-all rounded-[10px]">
                    Вернуться на главную
                </router-link>
            </div>
        </div>
    </div>
</div>
</template>

<style scoped>

</style>